import Vue from 'vue'
import Vuex from 'vuex'
const $ = require('jquery')
//require('jquery-ui')
// const contextPath = $("body").attr("contextPath")
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
	mdfId: "",
	selectID: 0,
	enableOptionInfoLink: false,
	evaluation: false,
	checkResult: {},
	customSelectChanged: false,
	mdfLoad: false, //金額計算処理を発動させる
	mdfLoading: false, //発動中かどうか
	status: "",
	errorBoxShow: false,
	warningBoxShow: false,
	errorSection: {
	    EPU: 1,
	},
	allSelects: [], //全プルダウンメニュー
	section: [],
	snackbar: {
	    // ref: null, //
	    message: '',
	    duration: 40000
	},
	refs: null, // ダイアログの制御の為
	//
	//inc_N8104_184: false //逼迫品対応
    },
    mutations: {
	setMdfId(state, id) {
	    state.mdfId = id
	},
	update(state, newResult) {
	    state.checkResult = newResult
	},
	customSelectChange(state, changed) {
	    //console.log("customSelectChange",changed)
	    state.customSelectChanged = changed
	},
	setMdfLoad(state, value) {
	    state.mdfLoad = value
	},
	setSelectID(state,value) {
	    state.selectID = value
	},
	addSelect(state,select) {
	    state.allSelects.push(select)
	    //if(!state.inc_N8104_184)
	    //  state.inc_N8104_184 = select.inc_N8104_184
	},
	allMenuUpdate(state) {
	    for(let s of state.allSelects) {
		//console.log(s.selected)
		//s.updated = false
		s.menuUpdates()
	    }
	},
	addSection(state,sec) {
	    state.section.push(sec)
	}
    },
    actions: {
	checkPrice({dispatch, commit, state}) {
	    //  transition効果の為
	    /* let tmp = {}
	    for(let p in state.checkResult)
		if('price' != p) tmp[p] = state.checkResult[p]
		state.checkResult = tmp */
	    /* if('price' in state.checkResult)
		//state.checkResult.price = state.checkResult.price.replace(/\w/g,"0")
		state.checkResult.price = '' */
	    
	    //console.log("contextPath: ", contextPath)
	    //console.log("checkPrice: ", $("form[name=construct]").serialize())
	    /* cancelしなくても呼び出し側でストップするよう変更
	    if(state.mdfLoading) {
		console.log("checkPrice canceled.")
		return
	    } */

	    state.mdfLoading = true
	    $.ajax({
		url: '../../PriceRemote.action',
		type: 'POST',
		dataType: 'json',
		data: $("form[name=construct]").serialize(),
		success: (res) => {
		    if(state.mdfLoad) {
			// i18n処理の為にMdf.actionの取得を同期処理にした為、
			// ダイアログのopen/close制御がbeforeMount処理内でできなくなった。
			// やむを得ずの対策として、初回の金額計算処理後にopen/closeを制御。
			state.mdfLoad = false
			// console.log('state: ', state.status)
			if('旧' == state.status) state.refs['oldAlert'].open()
		    }
		    
		    //タイムアウト対策追加
		    if(res.timeout) {
			console.log('mdf', state.mdfId)
			// 必ず先にmenuUpdateの処理が実行されるので、
			console.log("timeout...このケースはない？")
			//dispatch('rebuildSession').then(() => {
			//})
		    } else  {
			commit('update', res)
			//console.log(res.menuUpdate)
			commit('allMenuUpdate')

			// ...
			if('price' in res) {
			    $("#price").hide()
			    $("#price").slideDown(200)
			}

			// commitにしなくても動いた...
			state.errorBoxShow = ('errors' in res)
			// console.log(res.errors)
			state.errorSection = {}
			if(state.errorBoxShow) {
			    for(let key in res.errors) {
				if(res.errors[key]==null) continue;
				for(let section of res.errors[key]) {
				    //console.log("error section:",section)
				    if(document.getElementById(section)!=null) 
					state.errorSection[section] = 1
				}
			    }
			    //console.log("error sections",state.errorSection)
			}
			state.warningBoxShow = ('warnings' in res)
		    }
		    state.mdfLoading = false
		},
		error: (xhr,status,err) => {
		    // alert(err)
		    commit('update', {error: err})
		}
	    })
	},
	// Mdf.actionを呼び出すことにより、セッション再構築
	rebuildSession({commit,state}) {
	    // alert('セッションタイムアウトしました')
	    $.ajax({
		url: '../../Mdf.action?id='+state.mdfId,
		async: false,
		cache: false,
		dataType: 'xml',
		success: (res) => {
		    const dom = $(res)
		    const mdf = dom.find("mdf")[0]
		    // state.selectID = mdf.getAttribute("selectID")
		    commit('setSelectID',mdf.getAttribute("selectID"))

		    //カートも復活させる (同期処理)
		    //CartLocalSave.restore(function() {}, false)
		    if(storage && storage.cart) {
			//alert('セッションタイムアウトした為、カートに保存されていた内容を復元します...')
			const newSnack = {
			    //ref: state.snackbar.ref,
			    // message: 'セッションタイムアウトしました。\nカートに保存されていた内容を復元中...',
			    message: "retrievingCart",
			    duration: 4000   // => 同期処理中に更新しているので、このメッセージの次のメッセージから有効
			}
			state.snackbar = newSnack
			state.refs.snackbar.open()
			const dwr_options = {
			    async: true, //true or false
			    callback: function() {
				const newSnack = {
				    //ref: state.snackbar.ref,
				    message: 'cartRetrieved',
				    duration: 40000
				}
				state.snackbar = newSnack
				state.refs.snackbar.open()
				// commit('setMdfLoad',true)
			    }
			};
			CartService.load(storage.cart, dwr_options);
			storage.removeItem("preCart");
			// state.checkResult = { error: "カートの内容を復元中" }
		    } /* else {
			state.snackbar.message = 'セッションタイムアウトを検出...復元処理中'
			state.snackbar.duration = 4000
			state.snackbar.ref.open()
		    } */
		    
		    commit('setMdfLoad',true) // selectIDが更新されたので金額計算は
		                              // 画面描画後に実行する必要がある
		    //console.log("New selectID:",state.selectID);
		    // if(!storage.cart)  state.snackbar.ref.close()
		},
		error: (xhr,status,err) => {
		    // alert(err)
		    commit('update', {error: err})
		}
	    })
	}
    }
})




// WEBPACK FOOTER //
// ./src/PriceCheckStore.js